import { Analytics } from './analytics';

export class SocialMediaShareTracking {
   
   public static socialMediaSharing() {

      let emailLink = $('a.data-social-media-tracking');

      emailLink.click((e) => {
         let mediaClassName = $(e.currentTarget).attr('class');
         let mediaName = mediaClassName.split(' ').pop();

         Analytics.sendEvent('Addthis', mediaName , window.location.pathname)
      });   
   }
}